import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../api";
import { expressOnboardingApi } from "../modules/ExpressOnboarding/api/expressOnboardingApi";
import urls from "../urls";
import { siteWizardQuery } from "./useSiteWizard";

export function useSiteWizardMutations(siteId: number) {
  const queryClient = useQueryClient();
  const invalidateSiteWizard = () => {
    if (!siteId) return;
    queryClient.invalidateQueries({
      queryKey: expressOnboardingApi.base.key()
    });
    return queryClient.invalidateQueries({
      queryKey: siteWizardQuery(siteId).queryKey
    });
  };

  const updateOnboardingPhaseDoneMutation = useMutation({
    mutationFn: ({
      onboardingPhase,
      isDone
    }: {
      onboardingPhase: string;
      isDone: boolean;
    }) =>
      updateOnboardingPhaseDoneStatusRequest(siteId, onboardingPhase, isDone),
    onSettled: invalidateSiteWizard
  });

  const updateOnboardingProcessDoneMutation = useMutation({
    mutationFn: (isDone: boolean) =>
      updateOnboardingProcessDoneStatusRequest(siteId, isDone),
    onSettled: invalidateSiteWizard
  });

  return {
    updateOnboardingPhaseDoneMutation,
    updateOnboardingProcessDoneMutation
  };
}

function updateOnboardingPhaseDoneStatusRequest(
  siteId: number,
  onboardingPhase: string,
  isDone: boolean
) {
  return api.post(urls.api.onboardingPhaseUpdateDone(), {
    site: siteId,
    done: isDone,
    phase: onboardingPhase
  });
}

function updateOnboardingProcessDoneStatusRequest(
  siteId: number,
  isDone: boolean
) {
  return api.post(urls.api.onboardingProcessUpdateDone(), {
    site: siteId,
    done: isDone
  });
}
